// Canonical role names + legacy alias handling.
// Backend R1 migrated `coach` → `strength_coach` and `individual` → `general_client`.
// This helper keeps components resilient if a stale JWT/user doc arrives.

export const ROLES = {
  SUPER_ADMIN: "super_admin",
  ACADEMY_ADMIN: "academy_admin",
  STRENGTH_COACH: "strength_coach",
  FITNESS_TRAINER: "fitness_trainer",
  SPORTS_COACH: "sports_coach",
  ATHLETE: "athlete",
  GENERAL_CLIENT: "general_client",
  PARENT: "parent",
};

const LEGACY = { coach: "strength_coach", individual: "general_client" };

export const canonicalRole = (r) => {
  const k = (r || "").toLowerCase();
  return LEGACY[k] || k || "general_client";
};

export const isCoachRole = (r) => {
  const c = canonicalRole(r);
  return c === ROLES.STRENGTH_COACH || c === ROLES.FITNESS_TRAINER || c === ROLES.SPORTS_COACH;
};

// Default landing route per role. R2 registered the new dashboards.
export const dashboardPathFor = (r) => {
  switch (canonicalRole(r)) {
    case ROLES.SUPER_ADMIN:      return "/admin";
    case ROLES.ACADEMY_ADMIN:    return "/academy";
    case ROLES.STRENGTH_COACH:   return "/coach";            // canonical coach hub
    case ROLES.FITNESS_TRAINER:  return "/fitness-trainer";
    case ROLES.SPORTS_COACH:     return "/sports-coach";
    case ROLES.ATHLETE:          return "/athlete";
    case ROLES.PARENT:           return "/parent";
    case ROLES.GENERAL_CLIENT:
    default:                     return "/client";
  }
};
